import axios from "axios";
import moment from "moment";
import db from "../database";
import { v4 as uuidv4 } from "uuid";
import { getOAuthHeaders } from "../constants/oAuthValidation";

let authHeaders = {}; // Define it first to avoid errors

setTimeout(() => {
  authHeaders = getOAuthHeaders() || {};
  const { access_token } = authHeaders;

  if (access_token) {
    console.log("Token exists:", access_token);
  } else if (window.location.pathname !== "/sign-in") {
    window.location.assign("/sign-in");
  }
}, 0);

// if (access_token) {
//   console.log("Token exists:", access_token);
// } else {
//   // Prevent infinite redirect loop
//   if (window.location.pathname !== "/sign-in") {
//     window.location.assign("/sign-in"); // No #
//   }
// }

const retailURL = process.env.REACT_APP_serverUrl;
const domainURL = process.env.REACT_APP_domain;
const refreshTokenURL = process.env.REACT_APP_REFRESHTOKEN_URL;
// let tillId;
const retailInstance = axios.create();
retailInstance.defaults.baseURL = retailURL;
retailInstance.defaults.method = "POST";
retailInstance.defaults.headers.post["Content-Type"] = "application/json";
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const generateToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
      console.error("No refresh token found in localStorage.");
      window.location.assign("/sign-in");
      return;
    }

    if (!refreshTokenURL) {
      console.error("refreshTokenURL is undefined!");
      window.location.assign("/sign-in");
      return;
    }

    const res = await axios.post(
      refreshTokenURL,
      { refreshToken },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (res.status === 200) {
      console.log("Token refreshed successfully:", res.data);

      let d = new Date();
      d.setTime(d.getTime() + 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      let domain = `domain=${domainURL}`;

      document.cookie = `Enterprise.accessToken=${res.data.accessToken}; ${expires}; path=/; secure=true; SameSite=Strict; ${domain}`;
      document.cookie = `Enterprise.refreshToken=${res.data.refreshToken}; ${expires}; path=/; secure=true; SameSite=Strict; ${domain}`;
    } else {
      console.warn("Unexpected response:", res);
      window.location.assign("/sign-in");
    }
  } catch (error) {
    console.error("Error refreshing token:", error);
    window.location.assign("/sign-in");
  }
};

retailInstance.interceptors.request.use(
  (config) => {
    const authHeaders = getOAuthHeaders() || {}; // Fetch token dynamically
    const { access_token } = authHeaders;

    if (access_token) {
      config.headers.Authorization = `${access_token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

retailInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const { message } = JSON.parse(JSON.stringify(error));
    if (message === "Network error: Unexpected token < in JSON at position 0" || message === "Request failed with status code 401") {
      generateToken();
    } else {
      return Promise.reject(error);
    }
  }
);

const syncTillData = async (userData) => {
  try {
    const data = {
      query: `query {
            tillData(user: "${userData}") {
              posScanConfigs {
                cwrPosScanConfigId
                scanTrxType
                dataType
                barcodeLength
                startsWith
                endsWith
                customFormula
                calculateTax
                formula
                delimiter
                multiProducts
              }
              loyaltyApply {
                cwrLoyaltyLevelId
                name
                applicableFor
                prodCategories {
                  mProductCategoryId
                  include
                }
              }
              tillAccess {
                cwrTillaccessId
                csClientId
                csUserId
                userAccessController
                cashManagement
                productSync
                salesHistory
                parkedBills
                giftCard
                manualDiscount
                layAway
                dataSyncMonitor
                unlinkTill
                salesReport
                holdBill
                couponCode
                tillAccessMeta {
                  key
                  value
                }
                cwrTill {
                  cwrTillID
                  searchKey
                  till
                  description
                  nextAssignedNumber
                  prefix
                  suffix
                  loyaltyProgram
                  accessController
                  posType
                  manageCash
                  showopeningamount
                  showsalesamount
                  showexpectedamount
                  showdifferenceamount
                  shiftclose
                  shiftopen
                  eReceipt
                  printPreview
                  cashin
                  cashout
                  layAway
                  payNow
                  calculateTax
                  cashToKeep
                  hardwareController {
                    imageUrl
                    printReceipt
                    weighingScale
                    payment
                    printBarcode
                  }
                  pHWController {
                    imageUrl
                    printReceipt
                    weighingScale
                    payment
                    printBarcode
                  }
                  printTemplate {
                    cwrPrinttemplateId
                    name
                    htmlcode
                    htmlcode2
                    xmlcode
                    xmlcode2
                    obController
                    cwController
                  }
                  tillCloseTemplate {
                    cwrPrinttemplateId
                    name
                    htmlcode
                    htmlcode2
                    xmlcode
                    xmlcode2
                    obController
                  }
                  kotPrintTemplate {
                    cwrPrinttemplateId
                    name
                    htmlcode
                    htmlcode2
                    xmlcode
                    xmlcode2
                  }
                  cancelKotPrintTemplate {
                    cwrPrinttemplateId
                    name
                    htmlcode
                    htmlcode2
                    xmlcode
                    xmlcode2
                  }
                  salesReportTemplate {
                    cwrPrinttemplateId
                    name
                    htmlcode
                    htmlcode2
                    xmlcode
                    xmlcode2
                    obController
                  }
                }
                csBunit {
                  csBunitId
                  name
                  value
                  cwrSCustomerId
                  cwrCsDoctypeId
                  cwrPcatalogueId
                  isTaxIncluded
                  allowNegativeStock
                  cwrSpricelistId
                  enableLoyalty
                  pCatalogueSaleType {
                    cwrPcatalogueSaletypeId
                    isPromoApplicable
                    cwrSaletypeId
                  }
                  currencies {
                    csCurrencyId
                    currSymbol
                    isoCode
                    prcPrecision
                    stdPrecision
                    cstgPrecision
                    symbolRightSide
                    denominations {
                      value
                      seqNo
                    }
                    conversions {
                      csCurrencyIDTo
                      currencyFromRate
                      currencyToRate
                      validfromDate
                      validtoDate
                      isoCode
                    }
                  }
                  b2cCustomer {
                    cwrCustomerId
                    sPriceListId
                    code
                    name
                    email
                    mobileNo
                    pincode
                    retlLoyaltyBalance
                    b2cRegisteredstoreId
                    iscredit
                    balancePoints
                    loyaltyLevel {
                      cwrLoyaltyLevelId
                      name
                      accumulationRate
                      redemptionRate
                    }
                    sCustomer {
                      sCustomerID
                      customerCategory {
                        sCustomerCateforyId
                        value
                        name
                        description
                      }
                    }
                  }
                  paymentMethodList {
                    roundOffForPos
                    cWRPaymentMethodID
                    sequenceNo
                    finPaymentmethodId
                    finFinancialAccountId
                    finDayCloseAccountId
                    name
                    integratedPayment
                    isloyalty
                    paymentProvider
                    iscredit
                    isGiftCard
                    isCreditNote
                    isGiftVoucher
                    isDefault
                    csCurrencyId
                    isoCode
                    isactive
                    cwrTillId
                    saleTypeName
                    saleTypeId
                    paymentProviderDetails {
                      cwrPaymentProviderId
                      providerName
                      providerType
                      providerCode
                      tid
                      status
                      integrationType
                      providerConfigurations {
                        isSensitive
                        configValue
                        configKey
                      }
                    }
                    salesType {
                      cwrSaletypeId
                      name
                    }
                  }
                  mWarehouse {
                    mWarehouseID
                    name
                  }
                  customerAddress {
                    sCustomerAddressID
                    line1
                    line2
                    line3
                    fulladdress
                    phone
                    city
                    postalcode
                    csCountry {
                      csCountryID
                      name
                    }
                    csRegion {
                      csRegionID
                      name
                    }
                  }
                  locations {
                    csBunitLocationId
                    fulladdress
                    phone
                    contactPerson
                  }
                  salesRep {
                    code
                    name
                    salesRepresentId
                  }
                }
              }
              returnReasons {
                name
                value
                returnReasonId
              }
              status
              message
            }
          }`,
    };

    const resData = await retailInstance({
      data: data,
    });

    let tillData = resData?.data?.data?.tillData;

    // Check for successful status
    if (tillData?.status === "200") {
      tillData.time = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      localStorage.setItem("tillData", JSON.stringify(tillData));
      return true;
    } else {
      throw new Error(tillData?.message || "Failed to fetch Till data");
    }
  } catch (error) {
    console.error("Error syncing till data:", error.message);
    return false;
  }
};

const getStoreOps = async (id) => {
  try {
    const queryPayload = {
      query: `query {
                getStoreOps(storeId: "${id}", date: "${moment().format("YYYY-MM-DD HH:mm:ss")}") {
                    status
                    remarks
                }
            }`,
    };

    const response = await retailInstance({
      data: queryPayload,
    });

    return response;
  } catch (error) {
    console.error("Error in getStoreOps:", error);
  }
};

const tillRegistration = async (syncId, cwrTillID, search_key, timeMark, username) => {
  try {
    const queryPayload = {
      query: `mutation {
            tillRegistration(uniqueId: "${syncId}", tillId: "${cwrTillID}", storeOpsTillId: null,
              till: {
                searchKey: "${search_key}"
                created: "${timeMark}"
                updated: "${timeMark}"
                tillAccess: { csUser: { username: "${username}" } }
                tillHistory: {
                  domain: null
                  sessionid: null
                  osVersion: null
                  localIpAddress: null
                  macAddress: null
                  processor: null
                  ram: null
                  regTimestamp: "${timeMark}"
                }
              }
            ) {
              status
              message
              searchKey
              tillAccess {
                salesRep
                salesRepId
                csClientId
                csUser {
                  csUserId
                }
                cwrTill {
                  till
                  searchKey
                  description
                  nextAssignedNumber
                }
                csBunit {
                  csBunitId
                  name
                  cwrSCustomerId
                  csCurrency {
                    csCurrencyId
                    currSymbol
                    isoCode
                    stdPrecision
                    cstgPrecision
                    prcPrecision
                  }
                }
              }
              tillHistory {
                domain
                sessionid
                osVersion
                localIpAddress
                macAddress
                processor
                ram
                regTimestamp
                cwrTillRegHistoryId
              }
            }
          }`,
    };

    const response = await retailInstance({
      data: queryPayload,
    });

    return response;
  } catch (error) {
    console.error("Error in tillRegistration:", error);
  }
};

const posConfigService = async (cwrTillID) => {
  try {
    const queryPayload = {
      query: `
              query {
                getPOSConfig(tillId: "${cwrTillID}", name: null) {
                  cwrPosConfigId
                  name
                  posType
                  application
                  configJson
                  PricingRule
                  ExpiryDiscount
                  activateExpiryDiscount
                  registrationTypes
                  feedback
                }
              }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.error("Error in posConfigService:", error);
  }
};

const getTills = async (userid) => {
  try {
    const queryPayload = {
      query: `query {
            getTills(name: null userId: "${userid}") {
              cwrTillID
              till
              searchKey
              cSBunitID
              status
              name
              cSUserId
              userName
              tillHistory {
                cwrTillRegHistoryId
                regTimestamp
                ram
                processor
                sessionid
                macAddress
                domain
                localIpAddress
                csBunitId
              }
            }
          }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.error("Error in getTills:", error);
  }
};

const upsertTill = async (newStringRequest) => {
  try {
    const queryPayload = {
      query: `mutation{
            upsertTill(tillInfo:${newStringRequest})
            {    
              status
              message
              cwrTillID
              tillCash {
                cwrTillCashId
                date
                finPaymentmethodId
                opening
                sales
                notes
                netsales
                cashin
                cashout
                retainAmt
                closing
                returns
                iscash
                isclose
                storeDailyOpsTillid
                cashEvents {
                  cwrCashEventsID
                  amount
                  expected
                  diff
                  transactionCount
                  type
                  description
                  cashEventDetails {
                    cwrCashEventdetailsID
                    count
                    amount
                    denomination
                  }
                }
              }
            }
          }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.error("Error in upsertTill", error);
  }
};

const upsertSupplierPayment = async (newStringRequest) => {
  try {
    const queryPayload = {
      query: `mutation {
  upsertSupplierPayment(requests: [
    ${newStringRequest}
  ]) {
    status
    message
  }
}`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.log("error in upsertSupplierPayment", error);
  }
};

const unlinkTill = async (id) => {
  try {
    const queryPayload = {
      query: `mutation {
                    unlinkTill(tillId: "${id}") {
                      status
                      message
                    }
                  }`,
    };
    const response = await retailInstance({ data: queryPayload });
    return response;
  } catch (error) {
    console.error("Error in unlinkTill", error);
  }
};

const upsertPOSActivity = async (tillData) => {
  const tillObj = Array.isArray(tillData) ? tillData[0] : tillData;
  try {
    const queryPayload = {
      query: `mutation {
                                            upsertPOSActivity(tillActivity: [
                                              {
                                                csBunitId: "${tillObj.tillAccess[0].csBunit.csBunitId}"
                                                csUserId: "${tillObj.tillAccess[0].csUser.csUserId}"
                                                tillRegistrationId: "${tillObj.tillHistory[0].cwrTillRegHistoryId}"
                                                type: "LI"
                                                time: "${moment(new Date()).format("YYYY-MM-DD HH:mm:ss")}"
                                              }
                                            ]) {
                                              status
                                              message
                                            }
                                        }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.error("Error in upsertPOSActivity", error);
  }
};

const upsertStoreOps = async (id, userId) => {
  try {
    const mutationPayload = {
      query: `mutation {
                           upsertStoreOps(storeOps: {
                             cSBunitID: "${id}"
                             date: "${moment(new Date()).format("YYYY-MM-DD HH:mm:ss")}"
                             status: "OP"
                             closedBy: null
                             closeTime: null
                             openedBy: "${userId}"
                             openTime: "${moment(new Date()).format("YYYY-MM-DD HH:mm:ss")}"
                             remarks: null
                           }) {
                             status  
                             message
                           }
                         }`,
    };

    const response = await retailInstance({
      data: mutationPayload,
    });

    return response;
  } catch (error) {
    console.error("Error in upsertStoreOps", error);
  }
};

const upsertLoyaltyTransaction = async (tillData, value, cwrCustomerId, referenceId) => {
  try {
    const queryPayload = {
      query: `mutation {
            upsertLoyaltyTransaction(transaction: [{
                csBunitId: "${tillData.tillAccess.csBunit.csBunitId}"
                loyaltyPoints: ${value}
                b2cCustomerId: "${cwrCustomerId}"
                referenceId: "${referenceId}"
              }]) {
              status
              message
            }
          }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.log(error, "loyality transaction error");
  }
};

const verifyCredit = async (cwrCustomerId, amount) => {
  try {
    const queryPayload = {
      query: `query{
            verifyCredit(customerId:"${cwrCustomerId}", amount:${amount}){
                iscredit
                creditLimit
                creditBalance
                creditApproachPercentage
                code
                status
                message
            }
        }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.log(error, "verify credit error");
  }
};

const upsertCreditTransaction = async (transactionData) => {
  const stringifiedBody = JSON.stringify(transactionData).replace(/"/g, '\\"');
  try {
    const queryPayload = {
      query: `mutation {
        upsertCreditTransaction(creditTransactions: "${stringifiedBody}") {
          status
          message
        }
      }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.log(error, "upsert credit transaction error");
  }
};

const verifyLoyaltyRedemption = async (cwrCustomerId, csBunitId, loyalityPoints, cartTotal) => {
  const body = {
    customerId: cwrCustomerId,
    bunitId: csBunitId,
    points: loyalityPoints ? loyalityPoints : null,
    totalAmount: cartTotal,
  };
  const stringifiedBody = JSON.stringify(body).replace(/"/g, '\\"');
  try {
    const queryPayload = {
      query: `mutation {
        verifyLoyaltyRedemption(messageData: "${stringifiedBody}") {
          status
          message
        }
      }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.log(error, "verify loyalty redemption error");
  }
};

const validOtp = async (cwrCustomerId, otp, loyalityPoints) => {
  const body = {
    customerId: cwrCustomerId,
    otp: otp,
    points: loyalityPoints ? loyalityPoints : null,
  };
  const stringifiedBody = JSON.stringify(body).replace(/"/g, '\\"');
  try {
    const queryPayload = {
      query: `mutation {
        validOtp(messageData: "${stringifiedBody}") {
          status
          message
        }
      }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.log(error, "verify loyalty redemption error");
  }
};

const validOtpCoupon = async (userId, otp, couponData, mPricingRuleId) => {
  const cartObj = JSON.parse(localStorage.getItem("cartObj"));
  const mobileNo = cartObj?.customer?.mobileNo ? cartObj.customer.mobileNo : null;
  const body = {
    userId: userId,
    otp: otp,
    couponCode: couponData,
    contactNo: mobileNo,
    pricingRuleId: mPricingRuleId,
  };
  const stringifiedBody = JSON.stringify(body).replace(/"/g, '\\"');
  try {
    const queryPayload = {
      query: `mutation {
        validOtp(messageData: "${stringifiedBody}") {
          status
          message
        }
      }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.log(error, "verify loyalty redemption error");
  }
};

const sendOtpToUser = async (userId, pricingRule, couponCode, discount, totalStd) => {
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  let couponInfo = {};
  const rawCouponInfo = localStorage.getItem("couponAdditionalInfo");
  if (rawCouponInfo) {
    couponInfo = JSON.parse(rawCouponInfo);
  }
  const body = {
    couponCode: couponCode,
    discount: discount,
    totalStd: totalStd,
    discountInfo: couponInfo["Discount Reason"] || "",
    remarks: couponInfo["Remarks"] || "",
  };
  const stringifiedData = JSON.stringify(body).replace(/"/g, '\\"');
  try {
    const queryPayload = {
      query: `mutation {
  sendOtpToUser(userId: "${userId}", bunitId: "${tillData.tillAccess.csBunit.csBunitId}",pricingRuleId: "${pricingRule.mPricingrulesId}",  msgData: "${stringifiedData}" ) {
    status
    message
  }
}`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.log(error, "otp error");
  }
};

const discardGiftCard = async (cardNo, refNo, array = null) => {
  try {
    const giftCards = array
      ? JSON.stringify(array).replace(/"([^"]+)":/g, "$1:") // Convert array to GraphQL format
      : `[{ cardNo: "${cardNo}", referenceNo: "${refNo}" }]`;

    const queryPayload = {
      query: `mutation{
            discardGiftCard(giftCards: ${giftCards}) {
                status
                message
            }
        }`,
    };

    const response = await retailInstance({ data: queryPayload });
    return response;
  } catch (error) {
    console.log(error, "discard gift card error");
  }
};

const discardCouponService = async (couponInput, referenceId) => {
  try {
    const queryPayload = {
      query: `query{
            discardCoupon(couponcode:"${couponInput}",referenceId: "${referenceId}"){
                status
                message
            }
        }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.log(error, "discard coupon error");
  }
};

const createCustomerService = async (customerInput) => {
  try {
    const response = await retailInstance({
      data: customerInput,
    });
    return response;
  } catch (error) {
    console.log(error, "create customer error");
  }
};

const updateCustomerService = async (customerInput) => {
  try {
    const response = await retailInstance({
      data: customerInput,
    });
    return response;
  } catch (error) {
    console.log(error, "update customer error");
  }
};

const getCustomerService = async (customerInput) => {
  try {
    const response = await retailInstance({
      data: customerInput,
    });
    return response;
  } catch (error) {
    console.log(error, "get customer error");
  }
};

const verifyGiftCardService = async (giftCardInput) => {
  try {
    const response = await retailInstance({
      data: giftCardInput,
    });
    return response;
  } catch (error) {
    console.log(error, "verify gift card error");
  }
};

const checkGiftCard = async (giftCardInput) => {
  try {
    const response = await retailInstance({
      data: giftCardInput,
    });
    return response;
  } catch (error) {
    console.log(error, "check gift card error");
  }
};

const upsertGiftCardTransaction = async (giftCardTransactionInput) => {
  try {
    const response = await retailInstance({
      data: giftCardTransactionInput,
    });
    return response;
  } catch (error) {
    console.error("Error in upsertGiftCardTransaction:", error);
  }
};

const salesHistoryService = async (salesHistoryInput) => {
  try {
    const response = await retailInstance({
      data: salesHistoryInput,
    });
    return response;
  } catch (error) {
    console.log(error, "sales history error");
  }
};

const syncAllProductCategories = (tillId, syncId) => {
  const lastUpdatedTime = localStorage.getItem("lastUpdatedTime");
  return new Promise(async (posSaleTypeSyncSuccess, posSaleTypeSyncFailure) => {
    try {
      const paramsInput = {
        query: `query{
            getProductCategory(tillId:"${tillId}", lastSyncTime: ${lastUpdatedTime ? `"${lastUpdatedTime}"` : null}, timeZone:"${timeZone}"){
                mProductCategoryId
                name
                value
                description
                imageurl
                parentCategory{
                    mProductCategoryId
                    name
                    value
                    description
                    imageurl
                    parentCategory{
                        mProductCategoryId
                        name
                        value
                        description
                        imageurl
                        parentCategory{
                            mProductCategoryId
                            name
                            value
                            description
                            imageurl
                            parentCategory{
                                mProductCategoryId
                                name
                                value
                                description
                                imageurl
                            }
                        }
                    }
                }
            }
          }`,
      };

      const response = await retailInstance({
        data: paramsInput,
      });

      if (response.status === 200) {
        const { getProductCategory } = response.data.data;

        if (getProductCategory && getProductCategory.length > 0) {
          console.log("POS Sale Types: ", "Synced");

          const isArray = [];
          const finalArray = [];
          const seenNames = new Set();

          function getParentCategoryValue(obj) {
            if (!obj.parentCategory) {
              const id = obj.mProductCategoryId;
              if (!seenNames.has(id)) {
                isArray.push(obj);
                seenNames.add(id);
              }
              return id;
            }
            obj.id = obj.parentCategory.mProductCategoryId;
            finalArray.push({
              mProductCategoryId: obj.mProductCategoryId,
              name: obj.name,
              value: obj.value,
              description: obj.description,
              imageurl: obj.imageurl,
              id: obj.id,
              syncId: syncId,
            });

            return getParentCategoryValue(obj.parentCategory);
          }

          for (const obj of getProductCategory) {
            getParentCategoryValue(obj);
          }

          const seenId = new Set();
          isArray.forEach((item) => {
            const printArray = finalArray.reduce((result, current) => {
              const category = current.id;
              if (!result[category]) {
                result[category] = [];
              }
              const id = current.mProductCategoryId;
              if (!seenId.has(id)) {
                seenId.add(id);
                result[category].push(current);
              }
              return result;
            }, {});
            item.printArray = printArray;
          });

          const lastId = await db.AllProductCategories.bulkPut(isArray);
          posSaleTypeSyncSuccess(lastId);
        } else {
          posSaleTypeSyncSuccess();
        }
      } else {
        throw new Error(`Unexpected response status: ${response.status}`);
      }
    } catch (error) {
      console.error(`Error: ${error}`);
      posSaleTypeSyncFailure(error);
    }
  });
};

const syncProductCategories = (tillData, tillId, syncId) => {
  const lastUpdatedTime = localStorage.getItem("lastUpdatedTime");
  localStorage.setItem("sync1", true);
  let syncStartTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  return new Promise(async (productCategorySyncSuccess, productCategorySyncFailure) => {
    try {
      const paramsInput = {
        query: `query {
              productCategory(bunit:"${tillData.tillAccess.csBunit.csBunitId}", lastSyncTime: ${
                lastUpdatedTime ? `"${lastUpdatedTime}"` : null
              },uniqueId: "${syncId}",tillId:"${tillId}", storeOpsTillId: null, timeZone:"${timeZone}") {
              mProductCategoryId
              value
              name
              description
              imageurl
              }
            }`,
      };

      const response = await retailInstance({
        data: paramsInput,
      });

      const { productCategory } = response.data.data;

      if (response.status === 200 && productCategory.length > 0) {
        let syncEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        if (lastUpdatedTime) {
          let recordsData = 0;
          const latestIncrementalSync = await db.dataSyncSummary.where("syncType").equals("Full Sync").reverse().sortBy("syncEndTime");

          await Promise.all(
            productCategory.map(async (item) => {
              await db.productCategories
                .where("mProductCategoryId")
                .equals(item.mProductCategoryId)
                .toArray()
                .then(async (response) => {
                  if (response.length > 0) {
                    item.syncId = syncId;
                    await db.productCategories.update(item.mProductCategoryId, item);
                    recordsData = recordsData + 1;
                  } else {
                    item.syncId = syncId;
                    await db.productCategories.add(item);
                    recordsData = recordsData + 1;
                  }
                });
            })
          );
          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = { ...event.type, categories: { syncStartTime: syncStartTime, syncEndTime, records: recordsData } };
              event.records = (event.records ? event.records : 0) + recordsData;
            });
          if (latestIncrementalSync?.length > 0) {
            db.dataSyncSummary
              .where("syncId")
              .equals(latestIncrementalSync[0].syncId)
              .modify((event) => {
                event.type = {
                  ...event.type,
                  categories: { incremntalSyncStart: syncStartTime, incremntalSyncEnd: syncEndTime, incremntalSyncRecods: recordsData, ...event.type.categories },
                };
              });
          }
          await syncProductBrand(syncId, tillId);
        } else {
          productCategory.forEach((item) => {
            item.syncId = syncId;
          });
          const lastId = await db.productCategories.bulkPut(productCategory);
          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = { ...event.type, categories: { syncStartTime: syncStartTime, syncEndTime, records: productCategory.length } };
              event.records = (event.records ? event.records : 0) + productCategory.length;
            });
          console.log("Product Category: ", "Synced");
          productCategorySyncSuccess(lastId);
        }
        // Ensure syncProductBrand is called after successful product category sync
        await syncProductBrand(syncId, tillId);
        productCategorySyncSuccess();
      } else {
        productCategorySyncSuccess();
        await syncProductBrand(syncId, tillId);
      }
    } catch (error) {
      console.log("Product Category: ", "Sync Failed");
      productCategorySyncFailure(error);
    }
  });
};

const syncProductBrand = async (syncId, tillId) => {
  localStorage.setItem("sync1", true);
  // await db.productBrands.clear();
  const lastUpdatedTime = localStorage.getItem("lastUpdatedTime");
  const userData = JSON.parse(localStorage.getItem("userData"));
  let syncStartTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  if (!userData || !userData.cs_client_id) {
    console.error("User data or client ID is missing.");
    return Promise.reject("User data or client ID is missing.");
  }

  const paramsInput = {
    query: `query {
        getBrand(clientId: "${userData.cs_client_id}", lastSyncTime: ${
          lastUpdatedTime ? `"${lastUpdatedTime}"` : null
        },uniqueId: "${syncId}", tillId:"${tillId}", storeOpsTillId: null, timeZone:"${timeZone}") {
          brandId
          name
          value
        }
      }`,
  };

  return new Promise(async (resolve, reject) => {
    try {
      const response = await retailInstance({
        data: paramsInput,
      });

      const { getBrand } = response.data.data;
      if (response.status === 200 && getBrand && getBrand.length > 0) {
        let syncEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        if (lastUpdatedTime) {
          let recordsData = 0;
          const latestIncrementalSync = await db.dataSyncSummary.where("syncType").equals("Full Sync").reverse().sortBy("syncEndTime");
          await Promise.all(
            getBrand.map(async (item) => {
              const existingBrand = await db.productBrands.where("brandId").equals(item.brandId).first();
              // const existingBrand = await db.productBrands.where("brandId").equals(item.brandId).toArray();
              if (existingBrand) {
                // console.log(existingBrand, "-------->existing");
                recordsData = recordsData + 1;
                item.syncId = syncId;
                await db.productBrands.update(item.brandId, item);
                // console.log(`Brand with ID ${item.brandId} updated.`);
              } else {
                try {
                  item.syncId = syncId;
                  recordsData = recordsData + 1;
                  await db.productBrands.add(item);
                  // console.log(`New brand with ID ${item.brandId} added.`);
                } catch (error) {
                  console.error(`Failed to add new brand with ID ${item.brandId}: `, error);
                }
              }
            })
          );
          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = { ...event.type, brands: { syncStartTime: syncStartTime, syncEndTime, records: recordsData } };
              event.records = (event.records ? event.records : 0) + recordsData;
            });
          if (latestIncrementalSync?.length > 0) {
            db.dataSyncSummary
              .where("syncId")
              .equals(latestIncrementalSync[0].syncId)
              .modify((event) => {
                event.type = {
                  ...event.type,
                  brands: { incremntalSyncStart: syncStartTime, incremntalSyncEnd: syncEndTime, incremntalSyncRecods: recordsData, ...event.type.brands },
                };
              });
          }
        } else {
          getBrand.forEach((item) => {
            item.syncId = syncId;
          });
          await db.productBrands.bulkAdd(getBrand);
          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = { ...event.type, brands: { syncStartTime: syncStartTime, syncEndTime, records: getBrand.length } };
              event.records = (event.records ? event.records : 0) + getBrand.length;
            });
        }
        console.log("Product Brand: ", "Synced");
        resolve(); // Resolve the Promise after successful execution
      } else {
        console.log("Product Brand: ", "No new brands to sync");
        resolve(); // Resolve the Promise if there are no brands to sync
      }
    } catch (error) {
      console.error("Product Brand Sync Failed: ", error);
      reject(error); // Reject the Promise if an error occurs
    }
  });
};

const syncPosSaleTypes = async (syncId, tillId, tillData) => {
  const lastUpdatedTime = null;
  await db.posSaletypes.clear();
  let syncStartTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const latestIncrementalSync = await db.dataSyncSummary.where("syncType").equals("Full Sync").reverse().sortBy("syncEndTime");
  return new Promise(async (posSaleTypeSyncSuccess, posSaleTypeSyncFailure) => {
    try {
      const paramsInput = {
        query: `query{
            getPosSaletype(tillId:"${tillId}",catalogueId:"${tillData.tillAccess.csBunit.cwrPcatalogueId}", lastSyncTime: ${
              lastUpdatedTime ? `"${lastUpdatedTime}"` : null
            },uniqueId: "${syncId}", storeOpsTillId: null, timeZone:"${timeZone}"){
              cwrPcatalogueSaletypeId
              cSClientID
              cSBunitID
              created
              createdby
              updated
              updatedby
              isactive
              isPromoApplicable
              cwrPCatalogueId
              cwrSaletype{
                cwrSaletypeId
                value
                name
                isdefault
                colourCode
                enableLayaway
                enableKot
              }
              customer{
                    b2cCustomerId
                    code
                    name
                    email
                    mobileNo
                    pincode
                    retlLoyaltyBalance
                    b2cRegisteredstoreId
                    iscredit
                    balancePoints
                    sPriceListId
                    priceListName
                    cwrCustomerId
                    sCustomerId
                }
                additionalCharges {
                    chargeType
                    defaultPercentage
                    defaultAmount
                    minValue
                    maxValue
                    isEditableInPos
                    isTaxable
                    productId
                    taxId
                }
            }
          }`,
      };

      const response = await retailInstance({
        data: paramsInput,
      });

      const { getPosSaletype } = response.data.data;

      if (response.status === 200 && getPosSaletype?.length > 0) {
        let syncEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

        if (lastUpdatedTime) {
          let recordsData = 0;
          await Promise.all(
            getPosSaletype.map(async (item) => {
              item.customer.sCustomer = { sCustomerID: item.customer.sCustomerId };
              item.syncId = syncId;
              await db.posSaletypes
                .where("cwrSaletypeId")
                .equals(item.cwrSaletypeId)
                .toArray()
                .then(async (response) => {
                  if (response.length > 0) {
                    recordsData = recordsData + 1;
                    await db.posSaletypes.update(item.cwrSaletypeId, item);
                  } else {
                    recordsData = recordsData + 1;
                    await db.posSaletypes.add(item);
                  }
                });
            })
          );

          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = { ...event.type, posSaletypes: { syncStartTime: syncStartTime, syncEndTime, records: recordsData } };
              event.records = (event.records ? event.records : 0) + recordsData;
            });
          if (latestIncrementalSync?.length > 0) {
            db.dataSyncSummary
              .where("syncId")
              .equals(latestIncrementalSync[0].syncId)
              .modify((event) => {
                event.type = {
                  ...event.type,
                  posSaletypes: { incremntalSyncStart: syncStartTime, incremntalSyncEnd: syncEndTime, incremntalSyncRecods: recordsData, ...event.type.posSaletypes },
                };
              });
          }
        } else {
          getPosSaletype.forEach((item) => {
            item.customer.sCustomer = { sCustomerID: item.customer.sCustomerId };
            item.syncId = syncId;
          });
          const lastId = await db.posSaletypes.bulkPut(getPosSaletype);
          console.log("POS Sale Types: ", "Synced");
          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = { ...event.type, posSaletypes: { syncStartTime: syncStartTime, syncEndTime, records: getPosSaletype.length } };
              event.records = (event.records ? event.records : 0) + getPosSaletype.length;
            });
          posSaleTypeSyncSuccess(lastId);
        }
      } else {
        posSaleTypeSyncSuccess();
      }
    } catch (error) {
      console.log("POS Sale Types: ", "Sync Failed");
      posSaleTypeSyncFailure(error);
    }
  });
};

const syncProductsUom = async (syncId, tillId) => {
  const lastUpdatedTime = null;
  await db.productUom.clear();
  let syncStartTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const latestIncrementalSync = await db.dataSyncSummary.where("syncType").equals("Full Sync").reverse().sortBy("syncEndTime");
  return new Promise(async (uomSyncSuccess, uomSyncFailure) => {
    try {
      const paramsInput = {
        query: `query {
            getUom(lastSyncTime: ${lastUpdatedTime ? `"${lastUpdatedTime}"` : null},uniqueId: "${syncId}", tillId:"${tillId}", storeOpsTillId: null,timeZone:"${timeZone}") {
              csUomId
              costingprecision
              description
              ediCode
              name
              stdprecision
              symbol
              decimal
            }
          }`,
      };

      const response = await retailInstance({
        data: paramsInput,
      });

      const { getUom } = response.data.data;

      if (response.status === 200 && getUom.length > 0) {
        if (lastUpdatedTime) {
          let recordsData = 0;
          await Promise.all(
            getUom.map(async (item) => {
              item.syncId = syncId;
              const existingUom = await db.productUom.where("csUomId").equals(item.csUomId).toArray();
              if (existingUom.length > 0) {
                recordsData = recordsData + 1;
                await db.productUom.update(item.csUomId, item);
              } else {
                recordsData = recordsData + 1;
                await db.productUom.add(item);
              }
            })
          );
          let syncEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = { ...event.type, UOM: { syncStartTime: syncStartTime, syncEndTime, records: recordsData } };
              event.records = (event.records ? event.records : 0) + recordsData;
            });
          if (latestIncrementalSync?.length > 0) {
            db.dataSyncSummary
              .where("syncId")
              .equals(latestIncrementalSync[0].syncId)
              .modify((event) => {
                event.type = { ...event.type, UOM: { incremntalSyncStart: syncStartTime, incremntalSyncEnd: syncEndTime, incremntalSyncRecods: recordsData, ...event.type.UOM } };
              });
          }
        } else {
          getUom.forEach((uom) => {
            uom.syncId = syncId;
          });
          const lastId = await db.productUom.bulkPut(getUom);
          let syncEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = { ...event.type, UOM: { syncStartTime: syncStartTime, syncEndTime, records: getUom.length } };
              event.records = (event.records ? event.records : 0) + getUom.length;
            });
          console.log("POS Uom: ", "Synced");
          uomSyncSuccess(lastId);
        }
        uomSyncSuccess();
      } else {
        console.log("POS Uom: ", getUom);
        uomSyncSuccess();
      }
    } catch (error) {
      console.log("POS Uom: Sync Failed", error);
      uomSyncFailure(error);
    }
  });
};

const syncProducts = async (tillData, syncId, tillId) => {
  const lastUpdatedTime = localStorage.getItem("lastUpdatedTime");
  let syncStartTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  let recordsCount = 0;
  const latestIncrementalSync = await db.dataSyncSummary.where("syncType").equals("Full Sync").reverse().sortBy("syncEndTime");
  try {
    let from = 0;
    let limit = 5000;
    let productsSynced = false;
    while (!productsSynced) {
      const paramsInput = {
        query: `query {
                  getProducts1(bUnit:"${tillData.tillAccess.csBunit.csBunitId}", lastSyncTime: ${
                    lastUpdatedTime ? `"${lastUpdatedTime}"` : null
                  }, from:${from} limit:${limit},tillId:"${tillId}",uniqueId: "${syncId}", storeOpsTillId: null,timeZone:"${timeZone}") {
                    mProductId
                    csClientId
                    csBunitId
                    cwrPcatalogueId
                    created
                    createdby
                    updated
                    isactive
                    updatedby
                    sunitprice
                    slistprice
                    onhandQty
                    description
                    isVirtual
                    isBestSeller
                    cTaxId
                    taxRate
                    taxName
                    isPromoApplicable
                    isavailable
                    ismonday
                    istuesday
                    iswednesday
                    isthursday
                    isfriday
                    issaturday
                    issunday
                    colorcode
                    productionCenter
                    productionCenterId
                    preparationTime
                    cwrMenuTimeslot {
                      cwrMenuTimeslotId
                      name
                      startTime
                      endTime
                    }
                    mProduct {
                      csBunitId
                      bunitName
                      imageUrl
                      value
                      name
                      name2
                      type
                      csTaxcategoryId
                      mProductCategoryId
                      csUomId
                      uomName
                      upc
                      batchedProduct
                      isManualQty
                      isDecimal
                      imageurl
                      shortDescription
                      hsncode
                      returnable
                      returnDays
                      description
                      batchedForSale
                      batchedForStock
                      multiPrice
                      addNewLine
                      shelfLife
                      posPriceEdit
                      isBag
                      showAddons
                      foodType
                      productSegment
                      taxCategory {
                        csTaxcategoryID
                        name
                        overRideTax
                        overRideCondition
                        contraTaxCategoryId
                        contraTaxCategory
                        {
                          contraTaxCategoryName
                          contraTaxId
                          contraTaxName
                          contraRate
                        }
                      }
                      mBatch {
                        mBatchId
                        batchno
                        upc
                        price
                        listPrice
                        startdate
                        enddate
                        life
                      }
                      productGroup {
                        mProductGroupId
                        name
                        value
                        description
                      }
                      productAddons {
                        mProductAddOnId
                        name
                        price
                        mAddonGroup {
                          mAddonGroupId
                          name
                          maxqty
                          minqty
                          type
                          allowQtySelection
                        }
                        mAddonProduct {
                          mProductId
                          name
                        }
                      }
                      itemType
                      productAttributes {
                        mProductAttributeId
                        value
                        mAttributeGroup {
                          mAttributeGroupId
                          name
                        }
                        mAttribute {
                          mAttributeId
                          name
                        }
                      }
 
                      productManufacturer {
                        mProductManufacturerId
                        name
                        value
                        description
                      }
                      productBrand {
                        brandId
                        name
                        value
                        description
                      }
                      priceLists {
                          pricelist
                         pricestd
                          sPricelistId
                         sPriceList
                          uomId
                         uomName
                         effectiveFrom
                      }
                    customAttributes{
                      name
                        fileds {
                            name
                            type
                            values
                            defaultValue
                            mandatory
                        }
                      }
                    }
                  }
                }`,
      };
      from += 5000;
      const response = await retailInstance({
        data: paramsInput,
      });

      const { getProducts1 } = response.data.data;
      const products = getProducts1;
      const productsLength = products.length;
      if (productsLength > 0) {
        recordsCount = recordsCount + productsLength;
        const productsData = [];
        const brands = new Set();
        const categories = new Set();
        for (let i = 0; i < productsLength; i += 1) {
          const upcIndex = [];
          const batchIndex = [];
          if (products[i].mProduct.mBatch !== null) {
            for (let j = 0; j < products[i].mProduct.mBatch.length; j += 1) {
              batchIndex.push(products[i].mProduct.mBatch[j].batchno);
              upcIndex.push(products[i].mProduct.mBatch[j].upc);
            }
          }
          if (products[i].mProduct.upc !== null) {
            upcIndex.push(products[i].mProduct.upc);
          }
          let uomData = [];
          await db.productUom
            .where("csUomId")
            .equals(products[i].mProduct.csUomId)
            .toArray()
            .then((uom) => {
              if (uom.length > 0) {
                uomData = uom;
              }
            });
          const productDataObj = {
            mProductId: products[i].mProductId || "",
            csClientId: products[i].csClientId || "",
            csBunitId: products[i].mProduct.csBunitId || "",
            cwrPcatalogueId: products[i].cwrPcatalogueId || "",
            created: products[i].created || "",
            createdby: products[i].createdby || "",
            updated: products[i].updated || "",
            isactive: products[i].isactive ? products[i].isactive : false,
            productionCenter: products[i].productionCenter || "",
            productionCenterId: products[i].productionCenterId || "",
            preparationTime: products[i].preparationTime || "",
            updatedby: products[i].updatedby || "",
            sunitprice: products[i].sunitprice || 0,
            addNewLine: products[i].mProduct.addNewLine || "N",
            slistprice: products[i].slistprice || 0,
            onhandQty: products[i].onhandQty || 0,
            description: products[i].description || "",
            shortDescription: products[i].mProduct.shortDescription || "",
            isVirtual: products[i].isVirtual || "",
            isBestSeller: products[i].isBestSeller || "",
            cTaxId: products[i].cTaxId || "",
            taxRate: products[i].taxRate || 0,
            isPromoApplicable: products[i].isPromoApplicable || "",
            value: products[i].mProduct.value || "",
            showAddons: products[i].mProduct.showAddons || "N",
            foodType: products[i].mProduct.foodType || "",
            itemType: products[i].mProduct.itemType || "",
            name: products[i].mProduct.name || "",
            name2: products[i].mProduct.name2 || "",
            brandId: products[i].mProduct.productBrand.brandId || "",
            csTaxcategoryId: products[i].mProduct.csTaxcategoryId || "",
            mProductCategoryId: products[i].mProduct.mProductCategoryId || "",
            csUomId: products[i].mProduct.csUomId || "",
            uomName: products[i].mProduct.uomName || "",
            uomData: uomData || "",
            upc: products[i].mProduct.upc || "",
            batchedProduct: products[i].mProduct.batchedProduct || "",
            batchedForSale: products[i].mProduct.batchedForSale || "",
            batchedForStock: products[i].mProduct.batchedForStock || "",
            bunitName: products[i].mProduct.bunitName || "",
            imageUrl: products[i].mProduct.imageUrl || "",
            isManualQty: products[i].mProduct.isManualQty || "",
            isDecimal: products[i].mProduct.isDecimal || "",
            imageurl: products[i].mProduct.imageurl || "",
            productSegment: products[i].mProduct?.productSegment ? products[i].mProduct.productSegment : "",
            taxCategory: products[i].mProduct.taxCategory.name || "",
            taxName: products[i].taxName || "",
            taxFlag: "N",
            mBatch: products[i].mProduct.mBatch || "",
            hsncode: products[i].mProduct.hsncode || "",
            batchIndex: batchIndex || "",
            upcIndex: upcIndex || "",
            customAttributes: products[i].mProduct?.customAttributes?.fileds || [],
            cwrMenuTimeslot: products[i].cwrMenuTimeslot || [],
            type: products[i].mProduct.type || "",
            priceList: products[i].mProduct.priceLists,
            productManufacturerName: products[i].mProduct.productManufacturer.name || "",
            productManufacturerId: products[i].mProduct.productManufacturer.mProductManufacturerId || "",
            productBrandName: products[i].mProduct.productBrand.name || "",
            productBrandId: products[i].mProduct.productBrand.brandId || "",
            iscustomizable: products[i].mProduct?.iscustomizable || "",
            mProductGroupId: products[i]?.mProduct?.productGroup?.mProductGroupId || "",
            productCategoryName: products[i]?.mProduct?.productGroup?.name || "",
            productAddons: products[i]?.mProduct?.productAddons || [],
            multiPrice: products[i].mProduct.multiPrice || "",
            shelfLife: products[i].mProduct.shelfLife || "",
            posPriceEdit: products[i].mProduct.posPriceEdit || "",
            overRideTax: products[i].mProduct.taxCategory.overRideTax || "",
            overRideCondition: parseFloat(products[i].mProduct.taxCategory.overRideCondition) || "",
            contraRate: parseFloat(products[i].mProduct.taxCategory.contraTaxCategory?.contraRate) || "",
            contraTaxId: products[i].mProduct.taxCategory.contraTaxCategory?.contraTaxId || "",
            syncId: syncId,
          };
          brands.add(productDataObj.brandId);
          categories.add(productDataObj.mProductCategoryId);
          productsData.push(productDataObj);
        }
        let syncEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        if (lastUpdatedTime !== null) {
          let recordsData = 0;
          await Promise.all(
            productsData.map(async (item) => {
              await db.products
                .where("value")
                .equals(item.value)
                .toArray()
                .then(async (response) => {
                  if (response.length > 0) {
                    item.syncId = syncId;
                    recordsData = recordsData + 1;
                    await db.products.where("value").equals(item.value).modify(item);
                  } else {
                    item.syncId = syncId;
                    await db.products.add(item);
                    recordsData = recordsData + 1;
                  }
                });
            })
          );
          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = {
                ...event.type,
                products: { syncStartTime: syncStartTime, syncEndTime, records: event?.products?.records ? event?.products?.records + recordsData : recordsData },
              };
              event.records = (event?.records ? event?.records : 0) + recordsData;
            });
          if (latestIncrementalSync?.length > 0) {
            db.dataSyncSummary
              .where("syncId")
              .equals(latestIncrementalSync[0].syncId)
              .modify((event) => {
                event.type = {
                  ...event.type,
                  products: { incremntalSyncStart: syncStartTime, incremntalSyncEnd: syncEndTime, incremntalSyncRecods: recordsData, ...event.type?.products },
                };
              });
          }
        } else {
          const lastId = await db.products.bulkPut(productsData);
          console.log("Synced products count:", lastId);
          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = { ...event.type, products: { syncStartTime: syncStartTime, syncEndTime, records: recordsCount } };
              event.records = (event?.records ? event?.records : 0) + products.length;
            });
        }
      } else {
        console.log("Products: Synced");
        productsSynced = true;
      }
    }
    // Code to be executed after syncProducts completion
  } catch (error) {
    console.log("Products: Sync Failed");
    throw error;
  }
};

const syncPricingRules = async (tillData, syncId, tillId) => {
  const lastUpdatedTime = localStorage.getItem("lastUpdatedTime");
  // await db.pricingRules.clear();
  let syncStartTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const latestIncrementalSync = await db.dataSyncSummary.where("syncType").equals("Full Sync").reverse().sortBy("syncEndTime");
  return new Promise(async (pricingRulesSyncSuccess) => {
    try {
      const paramsInput = {
        query: `query {
              getPricingRules(catalogueId: "${tillData.tillAccess.csBunit.cwrPcatalogueId}", lastSyncTime: ${
                lastUpdatedTime ? `"${lastUpdatedTime}"` : null
              },tillId:"${tillId}",uniqueId: "${syncId}", storeOpsTillId: null, timeZone:"${timeZone}"){
                  mPricingrulesId
                  externalCoupon
                  couponProviderId
                  csClientId
                  csBunitId
                  created
                  createdBy
                  updated
                  updatedBy
                  upc
                  type
                  discountType
                  name
                  printedName
                  description
                  startDate
                  endDate
                  nextRule
                  percentageDiscount
                  amountDiscount
                  minimumQty
                  maximumQty
                  xQty
                  yQty
                  billAmount
                  maxBillAmount
                  cwrSaletypeId
                  fixedUnitPrice
                  timeSpecific
                  starttime
                  endtime
                  monday
                  tuesday
                  wednesday
                  thursday
                  friday
                  saturday
                  sunday
                  status
                  iscoupon
                  nextRule
                  priority
                  giftVoucherType
                  issueGiftVoucher
                  manualDiscount
                  excludeProductCategories
                  excludeBusinessUnits
                  excludeProducts
                  excludeB2CCustomers
                  excludeBrands
                  excludeCustomers
                  excludeCustomerCategory
                  excludeB2CSegment
                  enableApproval
                  commTemplateId
                  mPricingXProducts {
                      mPricingXProductId
                      line
                      mProductId
                      mBatchId
                      isFree
                      quantity
                  }
                  mPricingYProducts {
                      mPricingYProductId
                      line
                      mProductId
                  }
                  mPricingCcategories {
                      mPricingCcategoryId
                      line
                      sCustomerCategoryId
                  }
                  mPricingPcategories {
                      mPricingPcategoryId
                      line
                      mProductCategoryId
                  }
                  mPricingBrands {
                      mPricingBrandId
                      line
                      mBrandId
                  }
                  mPricingBUnits {
                      mPricingBUnitId
                      line
                      mBunitPricingId
                  }
                  mPricingQuantities {
                      mPricingQuantityId
                      line
                      quantity
                      discountValue
                  }
                  mPricingB2CCustomers {
                      mPricingB2cCustomerId
                      lineno
                      b2cCustomerId
                  }
                  mPricingB2CCustomerSegments {
                      mPricingB2CSegmentId
                      lineNo
                      cwrB2CCustomerSegmentId
                  }
                  mPricingExpiryDiscount {
                    rangeFrom
                    rangeTo
                    discountPercentage
                    mProductId
                }
                mPricingApprovals {
                    mPricingApprovalId
                    type
                    min
                    max
                    userId
                    roleId
                    userName
                    pin
                    role
                    enableOTP
                }
                additionalInfo {
                    fieldName
                    fieldType
                    mandatory
                    sequence
                    displayLabel
                    validationRule
                }
                couponProvider {
                  providerCode
                  providerName
                  apiConfig
                }
              }
          }`,
      };
      const response = await retailInstance({
        data: paramsInput,
      });

      const { getPricingRules } = response.data.data;
      if (response.status === 200 && getPricingRules.length > 0) {
        let syncEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        if (lastUpdatedTime) {
          let recordsData = 0;
          await Promise.all(
            getPricingRules.map(async (item) => {
              const existingRule = await db.pricingRules.where("mPricingrulesId").equals(item.mPricingrulesId).first();

              if (existingRule) {
                await db.pricingRules.delete(existingRule.id);
                // Update existing pricing rule
                item.syncId = syncId;
                await db.pricingRules.add(item);
                recordsData = recordsData + 1;
              } else {
                item.syncId = syncId;
                // Add new pricing rule
                recordsData = recordsData + 1;
                await db.pricingRules.add(item);
              }
            })
          );
          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = { ...event.type, pricingRules: { syncStartTime: syncStartTime, syncEndTime, records: recordsData } };
              event.records = (event.records ? event.records : 0) + recordsData;
            });
          if (latestIncrementalSync?.length > 0) {
            db.dataSyncSummary
              .where("syncId")
              .equals(latestIncrementalSync[0].syncId)
              .modify((event) => {
                event.type = {
                  ...event.type,
                  pricingRules: { incremntalSyncStart: syncStartTime, incremntalSyncEnd: syncEndTime, incremntalSyncRecods: recordsData, ...event.type.pricingRules },
                };
              });
          }
        } else {
          await db.pricingRules.clear();
          getPricingRules.forEach((item) => {
            item.syncId = syncId;
          });
          const lastId = await db.pricingRules.bulkPut(getPricingRules);
          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = { ...event.type, pricingRules: { syncStartTime: syncStartTime, syncEndTime, records: getPricingRules.length } };
              event.records = (event.records ? event.records : 0) + getPricingRules.length;
            });
          console.log("Product Pricing Rules: ", " Synced");
          pricingRulesSyncSuccess(lastId);
        }
        pricingRulesSyncSuccess();
      } else {
        console.log("Product Pricing Rules: ", getPricingRules);
        pricingRulesSyncSuccess();
      }
    } catch (error) {
      console.log("Product Pricing Rules: ", " Sync Failed");
      pricingRulesSyncSuccess();
    }
  });
};

const externalCoupon = async (url, token, body) => {
  try {
    const response = await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    console.log("API Success:", response.data);
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    return {
      error: true,
      data: {
        message: error.response?.data?.data?.message || error.response?.data?.message || "Something went wrong while redeeming the coupon.",
      },
    };
  }
};

const syncOfflineDta = async (tillData) => {
  try {
    const events = await db.tillEvents
      .where("tillStatus")
      .equals("closed")
      .filter((event) => event.isSynced === 0)
      .toArray();

    if (events.length > 0) {
      for (let i = 0; i < events.length; i += 1) {
        const event = events[i];
        const tillSession = JSON.parse(localStorage.getItem("tillSession"));
        const tillSessionId = tillSession?.tillSessionId;

        await db.tillEvents
          .where("tillSessionId")
          .equals(event?.tillSessionId)
          .modify((event) => {
            if (tillSessionId !== event?.tillSessionId) {
              event.tillStatus = "closed";
              event.isSynced = 1;
            }
          });

        const paramsInput = {
          query: `mutation{
              upsertTill(tillInfo:${events[i].tillInfo})
              {    
                status
                message
                cwrTillID
                tillCash{
                  cwrTillCashId
                  date
                  finPaymentmethodId
                  opening
                  sales
                  netsales
                  cashin
                  cashout
                  retainAmt
                  closing
                  returns
                  iscash
                  notes
                  isclose
                  storeDailyOpsTillid
                  cashEvents{
                    cwrCashEventsID
                    amount
                    expected
                    diff
                    transactionCount
                    type
                    description
                    cashEventDetails{
                      cwrCashEventdetailsID
                      count
                      amount
                      denomination
                    }
                  }
                }
              }
            }`,
        };

        try {
          const response = await retailInstance({
            data: paramsInput,
          });

          const result = response.data.data?.upsertTill;
          const status = result?.status;
          if (status === "200") {
            let tillData = event.tillRegistration;
            const queryData = {
              query: `mutation {
                    upsertPOSActivity(tillActivity: [
                      {
                        csBunitId: "${tillData[0]?.tillAccess[0]?.csBunit?.csBunitId}"
                        csUserId: "${tillData[0]?.tillAccess[0]?.csUser?.csUserId}"
                        tillRegistrationId: "${tillData[0]?.tillHistory[0]?.cwrTillRegHistoryId}"
                        type: "LO"
                        time: "${moment(new Date()).format("YYYY-MM-DD HH:mm:ss")}"
                      }
                    ]) {
                      status
                      message
                    }
                }`,
            };
            await retailInstance({
              data: queryData,
            });
          }
        } catch (error) {
          console.error("Error syncing offline data:", error.message);
        }
      }
    }
  } catch (error) {
    console.error("Error fetching events from DB:", error.message);
  }
};

const syncPosConfigData = (syncId, tillId) => {
  const lastUpdatedTime = localStorage.getItem("lastUpdatedTime");

  return new Promise(async (resolve, reject) => {
    try {
      const paramsInput = {
        query: `query {
              getPOSConfig(tillId: "${tillId}", name: null, lastSyncTime: ${
                lastUpdatedTime ? `"${lastUpdatedTime}"` : null
              }, uniqueId: "${syncId}", storeOpsTillId: null, timeZone:"${timeZone}") {
                cwrPosConfigId
                name
                posType
                application
                configJson
                PricingRule
                ExpiryDiscount
                activateExpiryDiscount
                registrationTypes
                feedback
              }
            }`,
      };

      const response = await retailInstance({
        data: paramsInput,
      });

      const posConfig = response.data.data.getPOSConfig;
      const feedbackData = posConfig[0]?.feedback ? JSON.parse(posConfig[0]?.feedback) : [];

      if (posConfig?.length > 0) {
        const posConfigData = JSON.parse(posConfig[0].configJson);
        const registrationTypes = JSON.parse(posConfig[0].registrationTypes) || [];
        localStorage.setItem("expiryDiscount", posConfig[0].activateExpiryDiscount);
        localStorage.setItem("posConfig", JSON.stringify(posConfigData));
        localStorage.setItem("registrationTypes", JSON.stringify(registrationTypes));
        localStorage.setItem("feedbackJson", JSON.stringify(feedbackData));
        console.log("POS Config: ", "Synced");
      } else {
        console.log("POS Config: No new config to sync");
      }
      resolve(); // Resolve the Promise after successful execution
    } catch (error) {
      console.log("POS Config: Sync Failed", error);
      reject(error); // Reject the Promise if an error occurs
    }
  });
};

const syncLoyalityData = async (syncId, tillId) => {
  const lastUpdatedTime = localStorage.getItem("lastUpdatedTime");
  let syncStartTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const latestIncrementalSync = await db.dataSyncSummary.where("syncType").equals("Full Sync").reverse().sortBy("syncEndTime");
  const loyalityQuery = {
    query: `query {
        getLoyaltyconfigurations(lastSyncTime: ${
          lastUpdatedTime ? `"${lastUpdatedTime}"` : null
        }, tillId:"${tillId}",uniqueId: "${syncId}", storeOpsTillId: null, timeZone:"${timeZone}") {
          loyaltylevelId
          name
          accumulationRate
          redemptionRate
          applicableFor
          isDefault
          levelId
          validityPeriod
          minPoints
          maxPoints
          sequence
          upgradeThreshold
          downgrade_threshold
          benefits
          noLoyaltyOnRedemption
          noLoyaltyOnDiscount
          LoyaltyAccumulation {
            loyaltyAccumulationId
            name
            description
            loyaltyLevelId
            pointsPerUnit
            mProductId
            product
            mProductCategoryId
            productCategory
            minPurchase
            startDate
            endDate
            loyaltyEvent
          }
          loyaltyRedemption {
            loyaltyRedemptionId
            ruleName
            description
            loyaltyLevelId
            pointsRequired
            redemptionValue
            minPurchase
            max_redemption
            startDate
            endDate
          }
          loyaltyEventCalenders {
            loyaltyEventCalenderId
            name
            description
            eventType
            startDate
            endDate
          }
        }
      }`,
  };

  return new Promise(async (resolve, reject) => {
    try {
      const response = await retailInstance({
        data: loyalityQuery,
      });
      const loyaltyConfigurations = response?.data?.data?.getLoyaltyconfigurations;

      if (loyaltyConfigurations?.length > 0) {
        let syncEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        if (lastUpdatedTime) {
          let recordsData = 0;
          await Promise.all(
            loyaltyConfigurations.map(async (item) => {
              const existingLoyalty = await db.loyalityData.where("loyaltylevelId").equals(item.loyaltylevelId).toArray();
              if (existingLoyalty.length > 0) {
                item.syncId = syncId;
                recordsData = recordsData + 1;
                await db.loyalityData.update(item.loyaltylevelId, item);
              } else {
                item.syncId = syncId;
                recordsData = recordsData + 1;
                await db.loyalityData.add(item);
              }
            })
          );
          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = { ...event.type, loyalityData: { syncStartTime: syncStartTime, syncEndTime, records: recordsData } };
              event.records = (event.records ? event.records : 0) + recordsData;
            });
          if (latestIncrementalSync?.length > 0) {
            db.dataSyncSummary
              .where("syncId")
              .equals(latestIncrementalSync[0].syncId)
              .modify((event) => {
                event.type = {
                  ...event.type,
                  loyalityData: { incremntalSyncStart: syncStartTime, incremntalSyncEnd: syncEndTime, incremntalSyncRecods: recordsData, ...event.type.loyalityData },
                };
              });
          }
        } else {
          loyaltyConfigurations.forEach((item) => {
            item.syncId = syncId;
          });
          await db.loyalityData.bulkPut(loyaltyConfigurations);
          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = { ...event.type, loyalityData: { syncStartTime: syncStartTime, syncEndTime, records: loyaltyConfigurations.length } };
              event.records = (event.records ? event.records : 0) + loyaltyConfigurations.length;
            });
        }
        console.log("Loyalty Data: ", "Synced");
      } else {
        console.log("Loyalty Data: No new data to sync");
      }
      resolve(); // Resolve the Promise after successful execution
    } catch (error) {
      console.log("Loyalty Data: Sync Failed", error);
      reject(error); // Reject the Promise if an error occurs
    }
  });
};

const syncGiftCardData = async (syncId, tillId) => {
  const lastUpdatedTime = localStorage.getItem("lastUpdatedTime");
  let syncStartTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const latestIncrementalSync = await db.dataSyncSummary.where("syncType").equals("Full Sync").reverse().sortBy("syncEndTime");
  const giftQuery = {
    query: `query {
        getGiftCardType(lastSyncTime: ${lastUpdatedTime ? `"${lastUpdatedTime}"` : null}, tillId:"${tillId}",uniqueId: "${syncId}", storeOpsTillId: null, timeZone:"${timeZone}") {
          cwrGiftcardTypeId
          name
          mProductId
          product
          type
          singleUse
          validity
          balanceLimit
          topupLimit
          prefix
          lengthCardNo
          pinRequired
          initialAmount
          giftCardGroup
          promotionEligible
          variableAmount
          printTemplate {
            cwrPrinttemplateId
            name
            htmlcode
            htmlcode2
            xmlcode
            xmlcode2
            obController
          }
        }
      }`,
  };

  return new Promise(async (resolve, reject) => {
    try {
      const response = await retailInstance({
        data: giftQuery,
      });

      const giftCardTypes = response.data.data.getGiftCardType;

      if (giftCardTypes.length > 0) {
        let syncEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        if (lastUpdatedTime) {
          let recordsData = 0;
          await Promise.all(
            giftCardTypes.map(async (item) => {
              const existingGiftCard = await db.giftCardData.where("cwrGiftcardTypeId").equals(item.cwrGiftcardTypeId).toArray();
              if (existingGiftCard.length > 0) {
                recordsData = recordsData + 1;
                item.syncId = syncId;
                await db.giftCardData.update(item.cwrGiftcardTypeId, item);
              } else {
                item.syncId = syncId;
                await db.giftCardData.add(item);
                recordsData = recordsData + 1;
              }
            })
          );

          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = {
                ...event.type,
                giftCardData: { syncStartTime: syncStartTime, syncEndTime, records: recordsData },
              };
              event.records = (event.records ? event.records : 0) + recordsData;
            });
          if (latestIncrementalSync?.length > 0) {
            db.dataSyncSummary
              .where("syncId")
              .equals(latestIncrementalSync[0].syncId)
              .modify((event) => {
                event.type = {
                  ...event.type,
                  giftCardData: { incremntalSyncStart: syncStartTime, incremntalSyncEnd: syncEndTime, incremntalSyncRecods: recordsData, ...event.type.giftCardData },
                };
              });
          }
        } else {
          giftCardTypes.forEach((item) => {
            item.syncId = syncId;
          });
          await db.giftCardData.bulkPut(giftCardTypes);
          db.dataSyncSummary
            .where("syncId")
            .equals(syncId)
            .modify((event) => {
              event.type = { ...event.type, giftCardData: { syncStartTime: syncStartTime, syncEndTime, records: giftCardTypes.length } };
              event.records = (event.records ? event.records : 0) + giftCardTypes.length;
            });
        }
        console.log("Gift Card Data: ", "Synced");
      } else {
        console.log("Gift Card Data: No new data to sync");
      }
      resolve(); // Resolve the Promise after successful execution
    } catch (error) {
      console.log("Gift Card Data: Sync Failed", error);
      reject(error); // Reject the Promise if an error occurs
    }
  });
};

const getApprovals = async () => {
  let tillId = JSON.parse(localStorage.getItem("tillValue"))?.cwr_till_id;
  let syncId = uuidv4().replace(/-/g, "").toUpperCase();
  await db.POSWorkFlowRules.clear();
  await db.approvers.clear();
  let syncStartTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const latestIncrementalSync = await db.dataSyncSummary.where("syncType").equals("Full Sync").reverse().sortBy("syncEndTime");
  try {
    const paramsInput = {
      query: `query {
            getPOSWorkflowRules(tillId:"${tillId}",uniqueId: "${syncId}", storeOpsTillId: null,){
                rules{
                cwrRulesId
               ruleName
               ruleCondition
               rulePriority
                cwrEventId
               eventId
               eventName
               apiType
               apiSource
               apiEndPoint
               triggerType
               }
               approvers {
                   name
                   pin
                   csUserId
                   csBunitId
                   bunitName
                   role
               }
              }
          }`,
    };
    const response = await retailInstance({
      data: paramsInput,
    });
    console.log(response, "------->appr");
    if (
      response?.data?.data?.getPOSWorkflowRules?.rules !== null &&
      response?.data?.data?.getPOSWorkflowRules?.rules !== undefined &&
      response?.data?.data?.getPOSWorkflowRules?.rules !== ""
    ) {
      await db.POSWorkFlowRules.bulkPut(response?.data?.data?.getPOSWorkflowRules?.rules);
    }

    const approvers = response?.data?.data?.getPOSWorkflowRules?.approvers || [];

    if (approvers.length > 0) {
      // Generate unique ids for each approver
      const approversWithIds = approvers.map((approver) => ({
        ...approver,
        id: uuidv4(), // Generate unique id
        syncId: syncId,
      }));

      // Add approvers with unique ids to IndexedDB
      await db.approvers.bulkAdd(approversWithIds);
      let syncEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      db.dataSyncSummary
        .where("syncId")
        .equals(syncId)
        .modify((event) => {
          event.type = { ...event.type, approvers: { syncStartTime: syncStartTime, syncEndTime, records: approversWithIds.length } };
          event.records = (event.records ? event.records : 0) + approversWithIds.length;
        });
      if (latestIncrementalSync?.length > 0) {
        db.dataSyncSummary
          .where("syncId")
          .equals(latestIncrementalSync[0].syncId)
          .modify((event) => {
            event.type = {
              ...event.type,
              approvers: { incremntalSyncStart: syncStartTime, incremntalSyncEnd: syncEndTime, incremntalSyncRecods: approversWithIds.length, ...event.type.approvers },
            };
          });
      }
    }
  } catch (error) {
    console.log("Approvals: Sync Failed");
    throw error;
  }
};

const getExpenseCategory = async (syncId) => {
  try {
    const queryPayload = {
      query: `query {
        getExpCategoryDetails(searchKey: null)
      }`,
    };

    const response = await retailInstance({ data: queryPayload });

    const rawData = response.data.data.getExpCategoryDetails;
    const expenseCategory = typeof rawData === "string" ? JSON.parse(rawData) : rawData;
    if (expenseCategory?.expenseCategories?.length) {
      await db.getExpenseCategory.bulkPut(expenseCategory.expenseCategories);
    } else {
    }

    return expenseCategory;
  } catch (error) {
    console.error(" Error:", error);
  }
};

const getCustomerWallet = async (cwrCustomerId) => {
  try {
    const queryPayload = {
      query: `query {
        getCustomerWallet(customerId: "${cwrCustomerId}")
      }`,
    };

    const response = await retailInstance({ data: queryPayload });
    const rawData = response.data.data.getCustomerWallet;
    console.log("rawData--->", rawData);
    const walletData = typeof rawData === "string" ? JSON.parse(rawData) : rawData;
    console.log("walletData--->", walletData);

    return walletData;
  } catch (error) {
    console.error("Error fetching customer wallet:", error);
    return [];
  }
};

const upsertWalletTransactionService = async (payload) => {
  try {
    const { bunitId, customerId, trxType, trxValue, payments, transactionDetails } = payload;

    const query = `
  mutation {
    upsertWalletTransaction(
      wallet: {
        bunitId: "${bunitId}"
        b2c_Customer_Id: "${customerId || ""}"
        trx_type: "${trxType || ""}"
        trx_value: ${trxValue || 0}
        payments: ${JSON.stringify(payments ?? []).replace(/"([^"]+)":/g, "$1:")}
        transactionDetails: "${JSON.stringify(transactionDetails ?? {})
          .replace(/\\/g, "\\\\")
          .replace(/"/g, '\\"')}"
      }
    ) {
      status
      message
      recordId
    }
  }
`;

    const response = await retailInstance({
      data: { query },
    });

    return response?.data?.data?.upsertWalletTransaction;
  } catch (err) {
    console.error("Error in upsertWalletTransaction:", err);
    throw err;
  }
};

const cancelPreorder = async (sOrderID, cancelReason) => {
  try {
    const query = `
  mutation {
  cancelPreOrder(s_orderId: "${sOrderID}", remarks: "${cancelReason}"){
    status,
    message
  }
}
  `;

    const response = await retailInstance({
      data: { query },
    });

    return response?.data?.data?.cancelPreOrder;
  } catch (err) {
    console.error("Error in cancelPreOrder:", err);
    throw err;
  }
};

const syncRestaurantTables = async () => {
  try {
    const tillData = JSON.parse(localStorage.getItem("tillData"));
    const tillId = tillData?.tillAccess?.cwrTill?.cwrTillID;

    if (!tillId) throw new Error("Till ID is not available");

    // Fetch restaurant tables data
    const getRestaurantTables = await fetchRestaurantTables(tillId);
    if (!getRestaurantTables || getRestaurantTables?.length === 0) {
      // throw new Error("No restaurant tables found");
    }

    // Process restaurant tables
    const { tempData, sectionData } = processRestaurantTables(getRestaurantTables);

    // Store section data
    await db.sectionTables.clear();
    await db.sectionTables.bulkAdd(sectionData);

    // Fetch occupied tables data
    const occupiedData = await fetchOccupiedTablesData();

    // Update table data with occupied information
    updateTableDataWithOccupiedInfo(tempData, occupiedData);

    // Store updated table data
    await db.tableData.clear();
    await db.tableData.bulkPut(tempData);

    return Promise.resolve();
  } catch (error) {
    return Promise.reject(error);
  }
};

// Function to fetch restaurant tables from the server
const fetchRestaurantTables = async (tillId) => {
  try {
    const query = `query {
      getRestaurantTables(tillId: "${tillId}") {
        cwrFbsectionId
        sectionName
        posTables {
          cwrFbTableId
          cSBunitID
          cSClientID
          created
          createdby
          csWindowId
          isactive
          updated
          updatedby
          name
          capacity
          cwrFbFloorId
        }
      }
    }`;

    const response = await retailInstance({
      data: { query },
    });

    return response?.data?.data?.getRestaurantTables;
  } catch (error) {
    console.log("Error in fetchRestaurant tables", error);
  }
};

// Function to process restaurant tables data
const processRestaurantTables = (getRestaurantTables) => {
  let tempData = [];
  let sectionData = [{ value: "all", name: "All" }];

  getRestaurantTables.forEach((section, index) => {
    section.posTables.forEach((table) => {
      table.title = table.name;
      table.merge = true;
      table.cwrFbsectionId = section.cwrFbsectionId;
      table.sectionName = section.sectionName;
      table.table = table.name;
      table.color = "#a7c957";
      table.statusType = "OPN";
      table.originalIndex = index;
      tempData.push(table);
    });
    sectionData.push({ value: section.cwrFbsectionId, name: section.sectionName });
  });

  return { tempData, sectionData };
};

// Function to fetch occupied tables data
const fetchOccupiedTablesData = async () => {
  try {
    const query = `query {
      getTableStatus(tableId: null) {
        cSBunitID
        cSClientID
        isactive
        fbTableId
        fbSectionId
        guestName
        guestType
        referredBy
        status
        salesRepId
        guests
        fbtableStatusId
      }
    }`;

    const response = await retailInstance({
      data: { query },
    });

    return response?.data?.data?.getTableStatus || [];
  } catch (error) {
    console.error(error, "Error in fetch occupied tables");
  }
};

// Function to update table data with occupied information
const updateTableDataWithOccupiedInfo = (tempData, occupiedData) => {
  occupiedData.forEach((occupied) => {
    const table = tempData.find((t) => t.cwrFbTableId === occupied.fbTableId);
    if (table) {
      table.color = getColorByStatus(occupied.status);
      table.noOfPersons = occupied.guests;
      table.guestName = occupied.guestName;
      table.guestType = occupied.guestType;
      table.referredBy = occupied.referredBy;
      table.fbtableStatusId = occupied.fbtableStatusId;
      table.statusType = occupied.status;
      table.waiter = occupied.salesRepId;
    }
  });
};

// Helper function to get color by table status
const getColorByStatus = (status) => {
  switch (status) {
    case "OCU":
      return "#bc4749"; // Occupied
    case "RES":
      return "#f2e8cf"; // Reserved
    case "OPN":
    default:
      return "#a7c957"; // Open
  }
};

const upsertPOSLogService = async (tillId, userId, bUnitId, dayOpeningArray) => {
  try {
    const queryPayload = {
      query: `
        mutation {
          upsertPOSLog(order: {
            tillId: "${tillId}",
            userId: "${userId}",
            bUnitId: "${bUnitId}",
            lines: [${dayOpeningArray}]
          }) {
            status  
            message
          }
        }
      `,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in upsert POS log service");
  }
};

const orderHistoryService = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in order history service");
  }
};

const generateGiftVoucher = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in generate gift voucher service");
  }
};

const posOrderProcessor1 = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in pos order processor service");
  }
};

const confirmPOSLayawayOrder1 = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in confirm pos layaway order service");
  }
};

const RFIDTag = async (data) => {
  try {
    const query = {
      query: `mutation{
      RFIDTag(rfidTag:[${data}]){
      status
      message
      }
      }`,
    };
    const response = await retailInstance({ data: query });
    return response;
  } catch (error) {
    console.error(error, "Error in RFID tag service");
  }
};

const verifyCouponsService = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in verify coupons service");
  }
};

const getNewOmsOrder = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in get new oms order service");
  }
};

const updateOmsOrder = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in update oms order service");
  }
};

const verifyReturn = async (data) => {
  try {
    const response = await retailInstance({ data });
    return response;
  } catch (error) {
    console.error("Error in verifyReturn:", error);
    return null; // Ensure caller knows it failed
  }
};

const getProductsNearbyStockService = async (data) => {
  try {
    const response = await retailInstance({ data });
    return response;
  } catch (error) {
    console.error("Error in getProductsNearbyStock:", error);
    return null; // Ensure caller knows it failed
  }
};

const customerSearch = async (data) => {
  try {
    const response = await retailInstance({ data });
    return response;
  } catch (error) {
    console.error("Error in customerSearch:", error);
    return null; // Ensure caller knows it failed
  }
};

const verifyStock = async (data) => {
  try {
    const response = await retailInstance({ data });
    return response;
  } catch (error) {
    console.error("Error in verify stock:", error);
    return null; // Ensure caller knows it failed
  }
};

const upsertOfdOrderStatus = async (orderId, statusCode, reason, reasonCode, isOnline) => {
  try {
    const queryPayload = {
      query: `mutation {
            upsertOfdOrderStatus(order: [{
              sOrderID: "${orderId}"
              ofdStatus: "${statusCode}"
              ${reason ? `reasonCode: "${reason}"` : ""}
              ${reasonCode ? `reasonCode: "${reasonCode}"` : ""}
              metaData: []
              isOnline: "${isOnline}"
            }]) {
              status
              message  
            }
          }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in upsert ofd order status");
  }
};

const salesHistoryAggregator = async (sortData, tillValue) => {
  try {
    const queryPayload = {
      query: `query {salesHistory(
                      q: null,
                      filter_by: null,
                      startRow: "0",
                      endRow: "100",
                      sort_by: "${sortData}",
                      tillId: "${tillValue?.cwr_till_id}"
                      aggregator: "Y"
                    ) {
                    sOrderID
                    documentno
                    dateordered
                    totalQty
                    orderTime
                    grosstotal
                    layAway
                    isReturn
                    ofdStatus
                    saleType {
                        cwrSaletypeId
                        name
                        value
                      }
                    cwrB2cCustomer {
                      name
                      }
                    cwrTill {
                      till
                    }
                  }        
                  }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in aggregator sales history");
  }
};

const customerSearchByName = async (value) => {
  try {
    const queryPayload = {
      query: `query{
          customerSearch(name:"${value}"){
            cwrCustomerId
            code  
            name
            email        
            mobileNo
            name
            pincode
            retlLoyaltyBalance
            b2cRegisteredstoreId
             iscredit
            loyaltyLevel{
                cwrLoyaltyLevelId
                name
                accumulationRate
                redemptionRate
            }
            cwrWallet {
                 wallet_Id
                balance_Amt
            }
            sCustomer{
              sCustomerID
              customerCategory{
                sCustomerCateforyId
                value
                name
                description
              }
            }
            csBunit{
              csBunitId
              name
            }
            b2cCustomerSegment{
              name
              cwrB2CCustomerSegmentId
            }
          }
        }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in customer search by name");
  }
};

const posOrderProcessor = async (data) => {
  try {
    const response = await retailInstance({ data });
    return response;
  } catch (error) {
    console.error("Error in posOrderProcessor:", error);
    return null; // Ensure caller knows it failed
  }
};

const confirmPOSLayawayOrder = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in confirm pos layaway order service");
  }
};

const getInventoryProductsService = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in get inventory products");
  }
};

const transactionQueue = async (query) => {
  const queryPayload = {
    query,
  };
  try {
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in transaction queue");
  }
};

const upsertWorkflowEventStore = async (uniqueId, aggregatorType, eventType, exceptionData) => {
  try {
    const queryPayload = {
      query: `mutation {
            upsertWorkflowEventStore(eventStore: [{
               aggregatorId:  "${uniqueId}"
               aggregatorType: "${aggregatorType}"
               eventType: "${eventType}"
               eventData: "${JSON.stringify(exceptionData).replace(/"/g, '\\"')}"
            }]) {
              status
              message
            }
          }`,
    };
    const response = await retailInstance({
      data: queryPayload,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in upsertWorkflowEventStore");
  }
};

const getNewOmsOrders = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in get new oms orders");
  }
};

const updateOMSOrderStatus = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in update oms order status");
  }
};

const upsertTableStatus = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in upsert table status");
  }
};

const cancelFBOrder = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in cancel fbo order");
  }
};

const upsertTableReservation = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in upsert table reservation");
  }
};

const upsertFBOrder = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in upsert fbo order");
  }
};

const getFBOrder = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in get fb order");
  }
};

const productionHistory = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in production history");
  }
};

const upsertBOMProduction = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in upsert bom production");
  }
};

const upsertProductionRMIssue = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in upsert production rm issue");
  }
};

const completePurchaseOrder = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in complete purchase order");
  }
};

const getUoms = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in get uom");
  }
};

const getPosSaletypes = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in get pos sale type");
  }
};

const getProductCategory = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in product category");
  }
};

const getRestaurantTables = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in get restaurant tables");
  }
};

const getPricingRule = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in get priding rules");
  }
};

const getProducts = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in get products");
  }
};

const salesHistoryDetails = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in sales history details");
  }
};

const upsertOfdOrderPrintStatus = async (data) => {
  try {
    const response = await retailInstance({
      data: data,
    });
    return response;
  } catch (error) {
    console.error(error, "Error in upsert ofd order print status");
  }
};

// services/index.js (Add to your existing services file)
const upsertPOSKOT = async (receiptData, tillData) => {
  try {
    // Assuming receiptData.vendors contains an array of vendor objects with productionCenter and items
    const vendors = receiptData.vendors || [];

    // Array to store results for all KOT insertions
    const results = [];

    // Iterate over each vendor to process KOT per production center
    for (const vendor of vendors) {
      // Construct KOT JSON for the specific vendor
      const tokenId = uuidv4().replace(/-/g, "");
      const kotJson = JSON.stringify({
        tokenId,
        orderId: receiptData?.sOrderID || "",
        orderNo: receiptData.documentno,
        tokenNo: vendor?.token || "",
        productionCenter: vendor?.productionCenter || "",
        productionCenterId: vendor?.productionCenterId || "",
        items: vendor?.items?.map((item) => ({
          qty: Math.floor(item.weight),
          productName: item.name,
          subProducts: item?.addons || [],
          preparationTime: item?.preparationTime || 1,
          notes: item?.notes || null,
        })),
        orderDate: receiptData.orderDate,
        orderTime: receiptData.orderTime,
        customer: receiptData.customer,
        total: vendor.items.reduce((sum, item) => sum + (item.total || 0), 0), // Calculate total for vendor items
        saleType: receiptData?.saleType || {},
        tableNo: receiptData?.tableNo || null,
      });

      // Prepare mutation payload for the specific production center
      const queryPayload = {
        query: `mutation {
          upsertPOSKOT(kot: [{
            cwrFbKotId: "${tokenId}"
            bunitId: "${tillData.tillAccess.csBunit.csBunitId}"
            cwrFbProductionCenterId: ${vendor.productionCenter ? `"${vendor.productionCenter}"` : null}
            kotJson: ${JSON.stringify(kotJson)}
            kotNo: ${vendor.token ? `"${vendor.token}"` : null}
            orderNo: ${receiptData.documentno ? `"${receiptData.documentno}"` : null}
            tillId: "${tillData.tillAccess.cwrTill.cwrTillID}"
            salesRepId: ${receiptData.salesRepId ? `"${receiptData.salesRepId}"` : null}
          }]) {
            status
            message
          }
        }`,
      };

      // Execute mutation using retailInstance
      const response = await retailInstance({
        data: queryPayload,
      });

      const result = response.data.upsertPOSKOT;
      if (result.status === "200") {
        console.log(`KOT inserted successfully for ${vendor.productionCenter} (Token: ${vendor.token}):`, result.message);
        results.push({ status: "Success", message: result.message, productionCenter: vendor.productionCenter, token: vendor.token });
      } else {
        console.error(`KOT insertion failed for ${vendor.productionCenter}:`, result.message);
        results.push({ status: "Error", message: result.message, productionCenter: vendor.productionCenter, token: vendor.token });
      }
    }

    // Check if all insertions were successful
    const allSuccess = results.every((result) => result.status === "Success");
    if (allSuccess) {
      return { status: "Success", message: "All KOTs inserted successfully", results };
    } else {
      return { status: "Error", message: "One or more KOT insertions failed", results };
    }
  } catch (error) {
    console.error("Error inserting KOTs:", error);
    return { status: "Error", message: error.message, results: [] };
  }
};

export {
  syncAllProductCategories,
  syncProductCategories,
  syncPosSaleTypes,
  syncProductsUom,
  syncProducts,
  syncPricingRules,
  syncOfflineDta,
  syncPosConfigData,
  syncLoyalityData,
  syncGiftCardData,
  getApprovals,
  getExpenseCategory,
  syncRestaurantTables,
  syncTillData,
  getStoreOps,
  upsertStoreOps,
  tillRegistration,
  upsertPOSActivity,
  posConfigService,
  getTills,
  upsertPOSLogService,
  upsertTill,
  upsertSupplierPayment,
  upsertLoyaltyTransaction,
  verifyCredit,
  upsertCreditTransaction,
  discardGiftCard,
  discardCouponService,
  createCustomerService,
  updateCustomerService,
  getCustomerService,
  verifyGiftCardService,
  checkGiftCard,
  upsertGiftCardTransaction,
  salesHistoryService,
  orderHistoryService,
  generateGiftVoucher,
  posOrderProcessor1,
  RFIDTag,
  confirmPOSLayawayOrder1,
  verifyCouponsService,
  getNewOmsOrder,
  updateOmsOrder,
  verifyReturn,
  customerSearch,
  verifyStock,
  unlinkTill,
  getProductsNearbyStockService,
  generateToken,
  verifyLoyaltyRedemption,
  validOtp,
  sendOtpToUser,
  upsertOfdOrderStatus,
  salesHistoryAggregator,
  customerSearchByName,
  posOrderProcessor,
  confirmPOSLayawayOrder,
  getInventoryProductsService,
  transactionQueue,
  upsertWorkflowEventStore,
  getNewOmsOrders,
  updateOMSOrderStatus,
  upsertTableStatus,
  cancelFBOrder,
  upsertTableReservation,
  upsertFBOrder,
  productionHistory,
  upsertBOMProduction,
  upsertProductionRMIssue,
  completePurchaseOrder,
  validOtpCoupon,
  getUoms,
  getPosSaletypes,
  getProductCategory,
  getRestaurantTables,
  getPricingRule,
  getProducts,
  salesHistoryDetails,
  upsertOfdOrderPrintStatus,
  getCustomerWallet,
  upsertWalletTransactionService,
  upsertPOSKOT,
  cancelPreorder,
  externalCoupon,
  fetchOccupiedTablesData,
  updateTableDataWithOccupiedInfo,
  processRestaurantTables,
  fetchRestaurantTables,
  getFBOrder,
};
